<h2 mat-dialog-title>Cloner le bien "{{data.prop.name}}"</h2>
<div mat-dialog-content>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="propertyCloneForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <mat-form-field class="w-100">
          <mat-label>Nombre de copie</mat-label>
          <input matInput placeholder="" type="number" required formControlName="count" />
          <mat-error>
            <span *ngIf="f('count').hasError('required')">Veuillez saisir un nombre</span>
            <span *ngIf="f('count').hasError('pattern')">Doit être un nombre entier</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-slide-toggle formControlName="withDocs" class="m-3">Cloner les documents</mat-slide-toggle>
      </div>
      <div class="row">
        <mat-slide-toggle formControlName="withPhotos" class="m-3">Cloner les photos</mat-slide-toggle>
      </div>
      <div class="row">
        <mat-slide-toggle formControlName="withChildren" class="m-3">Cloner les biens liés</mat-slide-toggle>
      </div>
      <div class="row">
        <mat-slide-toggle (change)="toggleDisplayChildrenNames()" [checked]="displayChildrenNames" class="m-3">Nommer
          les biens clonés</mat-slide-toggle>
      </div>
      <ng-container *ngIf="displayChildrenNames" formArrayName="newNames">
        <div class="row" *ngFor="let name of newNames.controls; let i = index">
          <mat-form-field [formGroupName]="i" class="w-100">
            <mat-label>Copie {{i+1}}</mat-label>
            <input matInput placeholder="" type="text" required formControlName="name" />
            <mat-error>
              <span *ngIf="name.hasError('maxlength')">Le nom ne doit pas dépasser 50 caractères</span>
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>

      <div class="formValidation" class="text-center">
        <button mat-flat-button class="m-2" color="primary" appTooltip="Créer le bien" type="submit"
          [disabled]="formSubmitting">
          Cloner
        </button>
        <button mat-flat-button class="m-2" color="primary" mat-dialog-close appTooltip="Annuler" (click)="onNoClick()">
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>
